export default __webpack_public_path__ + "static/media/up_arrow.986e50e9.svg";